module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.45c73723.eot";